import React from 'react';
import { BookOpen, Video, FileText, Users, Clock } from 'lucide-react';

const AdminLMSPage = () => {
  return (
    <div className="space-y-6" data-testid="admin-lms-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Learning Management System</h1>
        <p className="text-slate-500 mt-1">Manage course content and learning materials</p>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div className="bg-white rounded-xl p-6 border border-slate-200 text-center">
          <div className="w-12 h-12 bg-blue-100 rounded-xl mx-auto flex items-center justify-center mb-4">
            <Video className="w-6 h-6 text-blue-600" />
          </div>
          <h3 className="font-semibold text-slate-900">Video Lectures</h3>
          <p className="text-3xl font-bold text-blue-600 mt-2">156</p>
          <p className="text-sm text-slate-500">Total uploaded</p>
        </div>
        <div className="bg-white rounded-xl p-6 border border-slate-200 text-center">
          <div className="w-12 h-12 bg-purple-100 rounded-xl mx-auto flex items-center justify-center mb-4">
            <FileText className="w-6 h-6 text-purple-600" />
          </div>
          <h3 className="font-semibold text-slate-900">Study Materials</h3>
          <p className="text-3xl font-bold text-purple-600 mt-2">89</p>
          <p className="text-sm text-slate-500">PDFs & Documents</p>
        </div>
        <div className="bg-white rounded-xl p-6 border border-slate-200 text-center">
          <div className="w-12 h-12 bg-emerald-100 rounded-xl mx-auto flex items-center justify-center mb-4">
            <Users className="w-6 h-6 text-emerald-600" />
          </div>
          <h3 className="font-semibold text-slate-900">Active Learners</h3>
          <p className="text-3xl font-bold text-emerald-600 mt-2">1,250</p>
          <p className="text-sm text-slate-500">Currently learning</p>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 border border-slate-200">
        <h3 className="font-semibold text-slate-900 mb-4">LMS Features Coming Soon</h3>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-lg">
            <Clock className="w-5 h-5 text-amber-500" />
            <div>
              <p className="font-medium">Video Content Management</p>
              <p className="text-sm text-slate-500">Upload and organize course videos</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-lg">
            <Clock className="w-5 h-5 text-amber-500" />
            <div>
              <p className="font-medium">Quiz Builder</p>
              <p className="text-sm text-slate-500">Create interactive quizzes</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-lg">
            <Clock className="w-5 h-5 text-amber-500" />
            <div>
              <p className="font-medium">Progress Tracking</p>
              <p className="text-sm text-slate-500">Monitor student progress</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-lg">
            <Clock className="w-5 h-5 text-amber-500" />
            <div>
              <p className="font-medium">Live Classes</p>
              <p className="text-sm text-slate-500">Schedule and conduct live sessions</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLMSPage;
